import { jsx as _jsx } from "react/jsx-runtime";
import { Drawer } from '../../common';
export const DealerLocatorStoreDetailsDrawer = ({ storeDetailsDrawer, children }) => {
    return (_jsx(Drawer, { className: "u-color--Black", hideCloseButton: true, ...storeDetailsDrawer.drawerProps, children: children }));
};
